import { render, staticRenderFns } from "./MensajeInicialDos.vue?vue&type=template&id=26e7cd16&scoped=true"
import script from "./MensajeInicialDos.vue?vue&type=script&lang=js"
export * from "./MensajeInicialDos.vue?vue&type=script&lang=js"
import style0 from "./MensajeInicialDos.vue?vue&type=style&index=0&id=26e7cd16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e7cd16",
  null
  
)

export default component.exports